// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__97Wi2","resendInfoText":"OnGoingPaymentBox_resendInfoText__39DDa"};